<template>
  <div class="col-xs-12 col-sm-10 rs-account-contain-sty row">
    <div class="default-info-title-sty col-md-12">
      <h4 v-if="accountType === 'customer'">服務顧客履歷</h4>
      <h4 v-else>服務員履歷</h4>
      <hr/>
    </div>
    <div class="col-md-3">
      <div class="rs-account-subtitle-sty">
        <h5>基本資料</h5>
      </div>
      <div v-if="accountType === 'customer'">
        <div class="row">
          <div class="col-md-12" v-if="accountInfo.picture_url">
            <b-img center rounded="" :src="`${ accountInfo.picture_url }`" style="width: 150px;height: 150px; margin-bottom: 20px;" ></b-img>
          </div>
          <div class="col-md-12">
            <div class="order-info-group-sty">
              <div class="row">
                <div class="col-sm-3 order-info-label-sty">Line名稱</div>
                <div class="col-sm-9">{{ accountInfo.name }}</div>
              </div>
            </div>
            <div class="order-info-group-sty" v-if="accountInfo.names">
              <div class="row">
                <div class="col-sm-3 order-info-label-sty">訂單名稱</div>
                <div class="col-sm-9">{{ accountInfo.names }}</div>
              </div>
            </div>
            <div class="order-info-group-sty">
              <div class="row">
                <div class="col-sm-3 order-info-label-sty">電話</div>
                <div class="col-sm-9">{{ accountInfo.phone }}</div>
              </div>
            </div>
            <div class="order-info-group-sty">
              <div class="row">
                <div class="col-sm-3 order-info-label-sty">縣市</div>
                <div class="col-sm-9">
                  <div>{{ accountInfo.country }}</div>
                </div>
              </div>
            </div>
            <div class="order-info-group-sty">
              <div class="row">
                <div class="col-sm-3 order-info-label-sty">地區</div>
                <div class="col-sm-9">
                  <div>{{ accountInfo.city }}</div>
                </div>
              </div>
            </div>
            <!-- <div class="order-info-group-sty">
              <div class="row">
                <div class="col-md-12 order-info-label-sty">地址</div>
                <div class="col-md-12">{{ accountInfo.address1 }}</div>
              </div>
            </div>
            <div class="order-info-group-sty" v-if="accountInfo.address2">
              <div class="row">
                <div class="col-md-12 order-info-label-sty">社區或大樓名稱</div>
                <div class="col-md-12">{{ accountInfo.address2 }}</div>
              </div>
            </div> -->
            <div class="order-info-group-sty" v-if="accountInfo.birth">
              <div class="row">
                <div class="col-sm-3 order-info-label-sty">生日</div>
                <div class="col-sm-9">{{ accountInfo.birth }}</div>
              </div>
            </div>
          </div>
        </div>
        <hr/>
      </div>
      <div v-else>
        <div class="row">
          <div class="col-md-12" v-if="accountInfo.picture_url">
            <b-img center rounded="" :src="`${ accountInfo.picture_url }`" style="width: 150px;height: 150px; margin-bottom: 20px;" ></b-img>
          </div>
          <div class="col-md-12">
            <div class="order-info-group-sty">
              <div class="row">
                <div class="col-sm-3 order-info-label-sty">服務員</div>
                <div class="col-sm-9">{{ accountInfo.nick_name }}</div>
              </div>
            </div>
            <div class="order-info-group-sty" v-if="accountInfo.staff_level">
              <div class="row">
                <div class="col-sm-3 order-info-label-sty">服務員等級</div>
                <div class="col-sm-9">{{ accountInfo.staff_level }}</div>
              </div>
            </div>
            <div class="order-info-group-sty" v-if="accountInfo.gender">
              <div class="row">
                <div class="col-sm-3 order-info-label-sty">性別</div>
                <div class="col-sm-9">{{ accountInfo.gender }}</div>
              </div>
            </div>
            <div class="order-info-group-sty">
              <div class="row">
                <div class="col-sm-3 order-info-label-sty">聯絡電話</div>
                <div class="col-sm-9">{{ accountInfo.phone }}</div>
              </div>
            </div>
            <div class="order-info-group-sty">
              <div class="row">
                <div class="col-sm-3 order-info-label-sty">地區</div>
                <div class="col-sm-9">
                  <div>{{ accountInfo.country }}</div>
                  <div>{{ accountInfo.city }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr/>
      </div>
    </div>
    <div class="col-md-9">
      <div class="rs-account-subtitle-sty">
        <h5>訂單列表</h5>
      </div>
      <div class="col-md-12" style="height: 100vh;display: flex;justify-content: center;align-items: center;" v-if="isOrderLoad">
        <b-spinner style="width: 10em; height: 10rem;" label="Large Spinner" type="grow"></b-spinner>
      </div>
      <div v-else>
        <div class="" v-if="orderArray.length > 0">
          <div class="lst-order-sty" v-for="(order, index) in orderArray" :key="index" :class="{active: order.today}">
            <div class="list-order-id-sty" @click="goToContentDisplay(order)">
              <span class="order-id-sty" style="font-size: 16px;"># {{ order.id }} </span>
              <span class="list-order-date-sty" style="margin-left: 10px;font-size: 16px;">{{order.roc_date}} ( {{order.diplayWeekDay}} )</span>
              <span class="list-order-time-sty" style="font-size: 16px;">{{order.time_desc }}</span>
            </div>
            <hr>
            <div :id="'db-userorder-content-' +  index" class="rs-account-ordercontent" :ref="`db-userorder-list-content-` + index">
              <div class="list-order-maincontent-sty" @click="goToContentDisplay(order)">
                <div :class="`list-order-status-sty ${ order.statusClass }`">{{ order.status }}</div>
                <div  v-if="userType === 'staff'">
                  <b class="rs-order-name-sty">{{ order.name }}</b>,
                  <span class="list-order-location-sty">{{ order.city_country }}</span>
                </div>
                <!-- <div  v-if="userType === 'staff'">{{ order.phone }}</div> -->
                <div  v-if="order.staffs && order.staffs.length > 0">
                  <b v-for="(staff, sindex) in order.staffs" :key="sindex">
                    <span v-if='sindex > 0'> , {{ staff.displayN }}</span>
                    <span v-else>{{ staff.displayN }}</span>
                  </b>
                </div>
                <!-- <div :id="`db-list-otimeCashInfoArea-`+ index">
                  <div class="order-from-group">
                    <div class="row">
                      <div class="col-sm-3 order-info-label-sty">付款方式</div>
                      <div class="col-sm-9">{{ order.payment }}</div>
                    </div>
                  </div>
                  <div class="order-from-group" v-if="order.payment === '匯款'">
                    <div class="row">
                      <div class="col-sm-3 order-info-label-sty">付款後五碼</div>
                      <div class="col-sm-9"><b>{{ order.transfer_code }}</b></div>
                    </div>
                  </div>
                  <div class="order-from-group" v-if="order.force_price || order.free_trial">
                    <div class="row" v-if="order.force_price">
                      <div class="col-sm-3 order-info-label-sty">指定金額</div>
                      <div class="col-sm-9">每分鐘 {{ order.force_price }} 元</div>
                    </div>
                    <div class="row" v-if="order.free_trial">
                      <div class="col-sm-3 order-info-label-sty">免費體驗</div>
                      <div class="col-sm-9"><i class="db-icon-default db-icon-color-sucess db-icon-check"></i></div>
                    </div>
                  </div>
                  <div class="order-from-group" v-if="order.coupon_code">
                    <div class="row">
                      <div class="col-sm-3 order-info-label-sty">優惠碼</div>
                      <div class="col-sm-9">{{ order.coupon_code }}</div>
                    </div>
                  </div>
                  <div class="order-from-group" v-if="order.coupon_code_cost">
                    <div class="row">
                      <div class="col-sm-3 order-info-label-sty">優惠額度</div>
                      <div class="col-sm-9">{{ order.coupon_code_cost }}</div>
                    </div>
                  </div>
                  <div class="order-from-group">
                    <div class="row">
                      <div class="col-sm-3 order-info-label-sty">花費時間</div>
                      <div class="col-sm-9">{{ order.cost_time }}</div>
                    </div>
                  </div>
                  <div class="order-from-group">
                    <div class="row">
                      <div class="col-sm-3 order-info-label-sty">目前金額</div>
                      <div class="col-sm-9 order-staffcount-scuess">{{ order.cash }}</div>
                    </div>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
          <div class=""  v-if="orderTotals > pagePer">
            <b-pagination
              v-model="currentPage"
              :total-rows="orderTotals"
              :per-page="pagePer"
              first-text="|<<"
              prev-text="<"
              next-text=">"
              last-text=">>|"
              align="center"
              class="rs-order-pages-sty"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AccountInfo',
  props: {
    userId: String, // line user id
    userType: String
  },
  data () {
    return {
      accountId: '',
      accountType: 'customer', // customer, staff
      accountInfo: {},
      orderArray: [],
      isOrderLoad: false,
      currentPage: 1,
      pagePer: 10,
      orderTotals: 0
    }
  },
  created () {
    this.$nextTick(() => {
      this.getCurrentInfo()
    })
  },
  watch: {
    currentPage () {
      this.isOrderLoad = true
      this.getOrderInfo()
    }
  },
  methods: {
    getCurrentInfo () {
      const routeInfo = this.$store.getters.getRouteInfo
      if (routeInfo && routeInfo.category === 'account' && routeInfo.case && (routeInfo.id !== null || routeInfo.id !== undefined)) {
        this.accountType = routeInfo.case
        this.accountId = routeInfo.id
        this.getAccountInfo()
      } else {
        this.backToLastPath()
      }
    },
    getAccountInfo () {
      const self = this
      var isStaff = false
      var url
      const options = {
        id: this.accountId
      }
      var errorMsg = this.$toolDoc.defaultErrorMsg
      // var logMsg
      console.log('this.userType', this.userType)
      console.log('this.userType', this.userId)
      if (this.userType === 'staff') {
        isStaff = true
      }
      switch (this.accountType) {
        case 'customer':
          if (isStaff) {
            url = this.$apiDoc.staffUrl + this.userId + this.$apiDoc.apiGetCustomerInfo
          }
          break
        case 'staff':
          if (isStaff) {
            url = this.$apiDoc.staffUrl
          } else {
            url = this.$apiDoc.customerUrl
          }
          url += this.userId + this.$apiDoc.apiGetStaffInfo
          break
      }
      this.$api.get(url, options).then((resp) => {
        if (resp.result) {
          self.accountInfo = self.$toolDoc.arrangeAccountData(resp.data)
          if (isStaff) {
            self.getOrderInfo()
          }
        } else {
          if (resp.data) {
            errorMsg = resp.data
          }
          self.$bvToast.toast(errorMsg, {
            title: '',
            toaster: 'b-toaster-top-center',
            variant: 'danger',
            solid: true
          })
          self.backToLastPath()
        }
      }).catch((errorInfo) => {
        console.warn('errorInfo', errorInfo)
        alert(errorMsg)
        self.$parent.isLoadShow = false
      })
    },
    getOrderInfo () {
      const self = this
      const baseUrl = this.userType !== 'staff' ? this.$apiDoc.customerUrl : this.$apiDoc.staffUrl
      const getUrl = baseUrl + this.userId + this.$apiDoc.apiGetOrderDash
      var options = {
        page: this.currentPage,
        per: this.pagePer,
        exclude_disable: 1,
        date_order: 'desc'
      }
      var errorMsg = this.$toolDoc.defaultErrorMsg
      var logMsg
      var currentTimeArray = []
      var otherArray = []
      this.isOrderLoad = true
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })

      if (this.accountType === 'customer') {
        options.user_id = this.accountId
      } else {
        options.staff_id = this.accountId
      }
      this.$api.get(getUrl, options).then((resp) => {
        if (resp.result) {
          if (resp.data.order_infos && Array.isArray(resp.data.order_infos)) {
            self.orderArray = self.arrangeOrderData(resp.data.order_infos)
          } else {
            if (resp.data.current_time_list && Array.isArray(resp.data.current_time_list)) {
              currentTimeArray = self.arrangeOrderData(resp.data.current_time_list)
            }
            if (resp.data.list && Array.isArray(resp.data.list)) {
              otherArray = self.arrangeOrderData(resp.data.list)
            }
            self.orderArray = currentTimeArray.concat(otherArray)
          }
          self.orderTotals = resp.data.total_count
        } else {
          if (resp.data) {
            errorMsg = resp.data
          }
          self.$bvToast.toast(errorMsg, {
            title: '',
            toaster: 'b-toaster-top-center',
            variant: 'danger',
            solid: true
          })
        }
        self.isOrderLoad = false
      }).catch((errorInfo) => {
        logMsg = errorInfo
        console.warn(logMsg)
        self.$bvToast.toast(errorMsg, {
          title: '',
          toaster: 'b-toaster-top-center',
          variant: 'danger',
          solid: true
        })
        self.isOrderLoad = false
      })
    },
    arrangeOrderData (array) {
      const self = this
      array.forEach((item) => {
        item = self.$toolDoc.arrangeOrderData(item)
      })
      return array
    },
    // triggerContentDisplay (tIndex) {
    //   var targets = this.$el.querySelectorAll('.rs-account-ordercontent')
    //   if (targets) {
    //     targets.forEach((ele, index) => {
    //       if (index === tIndex) {
    //         if (ele.classList.contains('sty-hide')) {
    //           ele.classList.remove('sty-hide')
    //         } else {
    //           ele.classList.add('sty-hide')
    //         }
    //       } else {
    //         if (!ele.classList.contains('sty-hide')) {
    //           ele.classList.add('sty-hide')
    //         }
    //       }
    //     })
    //   }
    // },
    goToContentDisplay (orderData) {
      var idString
      var infoString = {}
      var url = '/' + this.$props.userType + this.$apiDoc.routerAccount + this.$apiDoc.routerAccountOrder
      if (orderData) {
        console.log('orderData, orderData')
        this.$store.dispatch('setAccountOrderData', orderData)
        infoString.order = orderData.id
        infoString.user = orderData.user_id
        idString = JSON.stringify(infoString)
        url += '#' + this.$tool.encodeString(idString)
        this.$router.push({ path: url, replace: true })
        location.reload()
      }
    },
    backToLastPath () {
      this.$router.go(-1)
    }
  }
}
</script>
